import { SwitchInput, SwitchTrack } from '@components/Field'
import React from 'react'
import { Row, RowDescription, RowText, RowTitle, ToggleWrapper } from './SwitchRow.styles'

interface SwitchRowProps {
	/** Ties the hidden checkbox to its track. */
	id: string
	/** Also the switch's accessible name. */
	title: string
	description?: React.ReactNode
	checked: boolean
	/** Dims the whole row, not just the switch. */
	disabled: boolean
	onChange: () => void
}

/** One of the modal's auto-saving switches: a title, an optional line under it, the switch on the right. */
const SwitchRow: React.FC<SwitchRowProps> = ({ id, title, description, checked, disabled, onChange }) => (
	<Row $disabled={disabled}>
		<RowText>
			<RowTitle>{title}</RowTitle>
			{description && <RowDescription>{description}</RowDescription>}
		</RowText>
		<ToggleWrapper>
			<SwitchInput id={id} aria-label={title} checked={checked} disabled={disabled} onChange={onChange} />
			<SwitchTrack htmlFor={id} $checked={checked} $disabled={disabled} />
		</ToggleWrapper>
	</Row>
)

export default SwitchRow
